import { is } from 'bpmn-js/lib/util/ModelUtil';

function hasDocumentation(element) {
  const bo = element.businessObject;
  return bo?.documentation?.length > 0 && bo.documentation[0]?.text;
}

function createBadgeHtml() {
  const badge = document.createElement('div');
  badge.className = 'doc-indicator-badge';
  badge.title = 'Dokumentation vorhanden';
  badge.textContent = '📝';
  return badge;
}

/**
 * Adds a small documentation indicator badge (📝) at bottom-right
 * of any BPMN element that has bpmn:documentation set.
 * Works in both Edit and View mode.
 */
export default function DocOverlayProvider(eventBus, overlays, elementRegistry) {
  const overlayMap = {};

  function updateOverlay(element) {
    if (!element?.businessObject) return;

    // Skip root elements and connections
    if (is(element, 'bpmn:Process') || is(element, 'bpmn:Collaboration')) return;
    if (element.waypoints) return;
    if (element.type === 'label') return;

    const elementId = element.id;

    // Remove existing overlay
    if (overlayMap[elementId]) {
      try {
        overlays.remove(overlayMap[elementId]);
      } catch (e) {
        console.debug('Overlay already removed for', elementId, e);
      }
      delete overlayMap[elementId];
    }

    // Add overlay if documentation exists
    if (hasDocumentation(element)) {
      try {
        overlayMap[elementId] = overlays.add(element, 'doc-indicator', {
          position: {
            bottom: 4,
            right: 4
          },
          html: createBadgeHtml(),
          show: {
            minZoom: 0.3
          },
          scale: {
            min: 1,
            max: 1
          }
        });
      } catch (e) {
        console.warn('Could not add doc overlay:', e);
      }
    }
  }

  function updateAll() {
    elementRegistry.forEach(function (element) {
      updateOverlay(element);
    });
  }

  eventBus.on('element.changed', function (event) {
    updateOverlay(event.element);
  });

  eventBus.on('import.done', function () {
    updateAll();
  });

  eventBus.on('commandStack.changed', function () {
    updateAll();
  });
}

DocOverlayProvider.$inject = ['eventBus', 'overlays', 'elementRegistry'];
